module.exports = __webpack_public_path__ + "media/piano_instrumental.e5106438.mp3";